// Клієнт імпорту рейтингу в БД ядра (/api/import/rating/*, див.
// Gurt_Systems_server/routes/import.js). На сервер іде лише розпізнаний набір
// рядків і SHA-256 файлу -- сирий файл не надсилається.
import { getAuthHeader, refreshAccessToken } from "./authToken.js";

const API = process.env.REACT_APP_API_BASE;

export class ImportApiError extends Error {
  constructor(status, data) {
    super((data?.error && String(data.error)) || `Помилка імпорту: ${status}`);
    this.status = status;
    this.data = data;
  }
}

async function importFetch(path, options = {}) {
  const doFetch = () => {
    const auth = getAuthHeader();
    return fetch(`${API}${path}`, {
      ...options,
      headers: {
        ...(auth ? { Authorization: auth } : {}),
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  };

  let response = await doFetch();
  if (response.status === 401) {
    const newToken = await refreshAccessToken(API);
    if (newToken) response = await doFetch();
  }

  const data = await response.json().catch(() => null);
  if (!response.ok) throw new ImportApiError(response.status, data);
  return data;
}

const post = (path, body) => importFetch(path, { method: "POST", body: JSON.stringify(body ?? {}) });

export function listDormitories() {
  return importFetch("/api/dormitories");
}

// Кімнати гуртожитку для вибору в попередньому перегляді: [{ id, number }].
export function listRooms(dormitoryId) {
  return importFetch(`/api/import/rooms?dormitoryId=${encodeURIComponent(dormitoryId)}`);
}

// body: { fileSha256, sheetName, dormitoryId, runType, periodStart, periodEnd, rows }
export function previewImport(body) {
  return post("/api/import/rating/preview", body);
}

export function getImportBatch(batchId) {
  return importFetch(`/api/import/rating/${batchId}`);
}

// patch: { gender?, course?, zone?, privilege?, studentId?, dormitoryId?, roomId? }
export function patchImportRow(batchId, rowNumber, patch) {
  return importFetch(`/api/import/rating/${batchId}/rows/${rowNumber}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export function setImportDefaultZone(batchId, zone) {
  return post(`/api/import/rating/${batchId}/default-zone`, { zone });
}

export function commitImport(batchId) {
  return post(`/api/import/rating/${batchId}/commit`);
}

export function confirmImport(batchId) {
  return post(`/api/import/rating/${batchId}/confirm`);
}

// Прев'ю відкату останнього зафіксованого пакета (нічого не змінює):
// { batch: null } або { batch, summary: { restore, delete, keep, scores,
// confirmedScores }, items: [{ rowNumber, studentId, pib, action, changes:
// [{ field, current, restored }], score }] }.
export function getLastCommittedImport() {
  return importFetch("/api/import/last-committed");
}

export function revertImport(batchId) {
  return post(`/api/import/rating/${batchId}/revert`);
}
